import { GetRowIdParams, GridApi } from "ag-grid-community";
import { AgGrid } from "@jsq/ds/core";
import { OverviewGraphqlDataSource } from "./billingGraphqlDataSource";
import { RowItem } from "./types";

/**
 * Gets a unique row ID for ag-grid based on clientId
 */
export const getRowId = (params: GetRowIdParams | Partial<GetRowIdParams>): string => {
  if (!params.data || typeof params.data !== "object") return "";
  return (params.data as RowItem).clientId?.toString() ?? "";
};

/**
 * Updates the grid's data source and refreshes the grid
 */
export const updateGridDataSource = (
  gridApi: GridApi | undefined,
  dataSource: OverviewGraphqlDataSource | null,
): void => {
  if (!gridApi || !dataSource) return;
  gridApi.setGridOption("serverSideDatasource", dataSource);
  gridApi.refreshServerSide({ purge: true });
};

/**
 * Handles the grid ready event by setting the grid API
 */
export const handleGridReady = (
  event: AgGrid.GridReadyEvent,
  setGridApi: (api: AgGrid.GridApi) => void,
  dataSource: OverviewGraphqlDataSource | null,
): void => {
  setGridApi(event.api);
  if (dataSource) {
    updateGridDataSource(event.api, dataSource);
  }
};
